import React from 'react';
import { StepFormWrapper } from '../../molecules/form-tab-presenter/form-tabStyles';
import Error from '../../Lottie/error';
import { Trans } from 'react-i18next';

interface ErrorTabProps {
  error: string;
}

const ErrorTab: React.FC<ErrorTabProps> = ({ error }) => {
  return (
    <StepFormWrapper $summary>
      <Error
        text={
          <Trans
            i18nKey={error}
            components={[
              <a
                href="mailto:support@oncampusabroad.com"
                style={{ color: 'inherit', textDecoration: 'underline' }}
              >
                support@oncampusabroad.com
              </a>
            ]}
          />
        }
      />
    </StepFormWrapper>
  );
};

export default ErrorTab;
